/* tslint:disable */
/* eslint-disable */
/**
 * BackOffice — Attributions par plateforme
 * Briques d\'un collaborateur par plateforme (override du compte, sémantique d\'override total avec repli sur le compte) et plafond délégable de la plateforme. Keyé par COLLABORATEUR (abpUserId) : un cabinet de N collaborateurs expose N lignes, et les collaborateurs d\'une corporate (sans ligne Courtier) sont adressables. Surface admin de l\'atelier des rôles + surface gouvernance du Portail Plateforme. 
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BriqueAttribuableDto
 */
export interface BriqueAttribuableDto {
    /**
     * 
     * @type {string}
     * @memberof BriqueAttribuableDto
     */
    nom: string;
    /**
     * 
     * @type {string}
     * @memberof BriqueAttribuableDto
     */
    description?: string | null;
}

/**
 * Check if a given object implements the BriqueAttribuableDto interface.
 */
export function instanceOfBriqueAttribuableDto(value: object): value is BriqueAttribuableDto {
    if (!('nom' in value) || value['nom'] === undefined) return false;
    return true;
}

export function BriqueAttribuableDtoFromJSON(json: any): BriqueAttribuableDto {
    return BriqueAttribuableDtoFromJSONTyped(json, false);
}

export function BriqueAttribuableDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): BriqueAttribuableDto {
    if (json == null) {
        return json;
    }
    return {
        
        'nom': json['nom'],
        'description': json['description'] == null ? undefined : json['description'],
    };
}

export function BriqueAttribuableDtoToJSON(json: any): BriqueAttribuableDto {
    return BriqueAttribuableDtoToJSONTyped(json, false);
}

export function BriqueAttribuableDtoToJSONTyped(value?: BriqueAttribuableDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'nom': value['nom'],
        'description': value['description'],
    };
}

